const theme = {
    dark: {
        primary: "#212428",
        bg: "#1A1D20",
        secondary: "#ff014E",
        textColor: "rgba(255, 255, 255, 0.7)"
    },
    light: {
        primary: "rgba(255, 255, 255, .2)",
        bg: "#FDF4DC",
        secondary: "#ff014E",
        textColor: "rgba(0, 0, 0)",
        textLightColor: "rgba(0,0,0,0.8)"
    },

}

export default theme;